import axios from 'axios'
import security from '../support/security'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.withCredentials = true;
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.API_HOST,
  // 超时
  timeout: 20000
})
// request拦截器
service.interceptors.request.use(config => {
  // 请求头带上tid
  config.headers.tid = security.getToken();
  return config
}, error => {
    console.log(error)
    return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    var result = res.data;
    var errorCode = result.errorCode;
	var errorMsg = result.errorMsg;
    if(security.isTokenInvalidate(errorCode)) {

      try{
        layui.layer.closeAll('loading');
      }catch(e){}

      return Promise.reject('token invalidate!');
    } else if (security.isAuthInvalidate(errorCode)){

      try{
        layui.layer.closeAll('loading');
      }catch(e){}

      return Promise.reject('auth invalidate!');
    }  else { 
      if(errorCode){
        console.error('service interceptor: ' + errorMsg);
      }
      return result;
    }
  },
  error => {
    console.log('err' + error)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/network/networkconfig.js